document.addEventListener("DOMContentLoaded", function () {

  const titles = document.querySelectorAll(".faq_title_box");

  titles.forEach(title => {

    // 初期状態で閉じる
    const content = title.nextElementSibling;
    content.style.display = "none";

    title.addEventListener("click", function () {

      titles.forEach(otherTitle => {
        if (otherTitle !== title) {
          otherTitle.classList.remove("active");
          otherTitle.nextElementSibling.style.display = "none";
        }
      });

      title.classList.toggle("active");

      if (content.style.display === "none") {
        content.style.display = "block";
      } else {
        content.style.display = "none";
      }

    });

  });

});